import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { MsalModule } from '@azure/msal-angular';
import { NgxSpinnerModule } from 'ngx-spinner';
import { NgxPaginationModule } from 'ngx-pagination';
import { AgGridAngular } from '@ag-grid-community/angular';
import { NgSelectModule } from '@ng-select/ng-select';


import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgToggleModule } from 'ng-toggle-button';
import { FormErrorComponentComponent } from './components/form-error-component/form-error-component.component';
import { OnlyNumberDirective } from './directives/only-number.directive';




@NgModule({
  declarations: [
    FormErrorComponentComponent,
    OnlyNumberDirective,
  ],
  imports: [
    CommonModule,
    NgbModule,
    MsalModule,
    NgxSpinnerModule,
    NgxPaginationModule,
    AgGridAngular,
    NgSelectModule,
    BsDatepickerModule,
    FormsModule,
    ReactiveFormsModule,
    NgToggleModule,

  ],
  exports: [
    NgbModule,
    MsalModule,
    NgxSpinnerModule,
    AgGridAngular,
    NgSelectModule,
    FormErrorComponentComponent,
    NgToggleModule,
    OnlyNumberDirective


  ],
})
export class SharedModule {}
